import { useMemo } from 'react'
import { IconButton, Tooltip, Chip } from '@mui/material'
import PrintIcon from '@mui/icons-material/Print'
import ServerDataGrid from '../../components/ServerDataGrid'
import { useAuth } from '../../auth/AuthContext'
import { useNotify } from '../../components/Notifications'
import { formatNumber } from '../../utils/format'

// Documentos emitidos — grid SERVER-SIDE (DataTables). Reemplaza el view=BaseList que traía
// las 2586 filas (5.3s) por la página real (10 filas, ~0.5s). Filtro base = locación del
// usuario + excluye estados preparado/agendado (igual que el ERP).
export default function DocumentosPage() {
  const { auth } = useAuth()
  const notify = useNotify()

  const baseFilter = useMemo(() => ({
    type: 'and',
    filters: [
      ...(auth?.locacionId != null ? [{ path: 'locacion.id', equals: auth.locacionId }] : []),
      { path: 'estado.codigo', notEquals: 'comp_venta_preparado' },
      { path: 'estado.codigo', notEquals: 'comp_venta_agendado' },
    ],
  }), [auth?.locacionId])

  const reimprimir = (row) => notify.info(`Reimpresión del comprobante ${row.numero || row.id} (pendiente de wiring del KuDE).`)

  const columns = [
    { data: 'numero', label: 'Número' },
    { data: 'fecha', label: 'Fecha', type: 'date-range' },
    { data: 'cliente.nombre', label: 'Cliente' },
    { data: 'montoTotal', label: 'Total', type: 'number-range', align: 'right', render: (r) => formatNumber(r.montoTotal || 0, 0) },
    { data: 'estado.descripcion', label: 'Estado', type: 'combo', render: (r) => <Chip size="small" label={r.estado?.descripcion || '—'} /> },
    { data: 'estadoSifen.descripcion', label: 'SIFEN', type: 'combo' },
  ]

  return (
    <ServerDataGrid
      title="Documentos emitidos"
      resource="comprobanteventa"
      view="ConsultaComprobanteVentaList"
      baseFilter={baseFilter}
      columns={columns}
      defaultOrderDir="desc"
      pageSize={10}
      rowActions={(row) => (
        <Tooltip title="Reimprimir KuDE/ticket">
          <IconButton size="small" onClick={() => reimprimir(row)}><PrintIcon fontSize="small" /></IconButton>
        </Tooltip>
      )}
    />
  )
}
